import script from "./CardsViajesSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsViajesSelector.vue?vue&type=script&setup=true&lang=js"

import "./CardsViajesSelector.vue?vue&type=style&index=0&id=69af63d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69af63d1"]])

export default __exports__